<template>
    <div class="vx-col w-full">
        <vx-card title="Driver List">
            <div slot="no-body" class="mt-4" :key="key">
                <vs-table :data="drivers" class="table-dark-inverted" search>
                    <template slot="thead">
                        <vs-th sort-key="name">Description</vs-th>
                        <vs-th>ONLINE</vs-th>
                        <vs-th>SELECT</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].first_name">
                                <div>{{data[indextr].first_name}} {{data[indextr].last_name}}</div>
                                <div class="mt-2">{{data[indextr].email}}</div>
                                <div class="mt-2">{{data[indextr].phonenumber}}</div>
                            </vs-td>
                            <vs-td :data="data[indextr].stats">
                                <vs-button :color="data[indextr].is_online ? '#469600' : '#bc1254'" type="flat" icon="fiber_manual_record" :title="data[indextr].is_online ? 'Online' : 'Offline'"></vs-button>
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                                <vs-button type="gradient" icon="create" radius title="Select" @click="onClickSelectDriver(data[indextr])"></vs-button>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vx-card>
    </div>
</template>

<script>

import Crypto from '@/helper/crypto'
import Global from '@/helper/global'
import ErrorHandler from '@/helper/error_handler'

export default {
    name: 'available-driver-list',
    data () {
        return {
            drivers: [],
            key: 1
        }
    },
    mounted(){
        this.retrieveDriverList();
    },
    methods: {
        onClickSelectDriver(driver){
            this.$emit('onSelect', driver)
        },
        retrieveDriverList(){
            this.$vs.loading({
                type: 'radius',
                text:'Retrieving data ...'
            })

            this.$http.get(this.$endpoints.admin_active_drivers)
            .then(res => {
                let response = res.data.data
                this.drivers = response.data
                this.$vs.loading.close()
            })
            .catch(err => {
                  console.log(err)
            })
        }
    }
}
</script>
